import z from 'zod';
import { membershipFormSchema } from 'src/features/membership/formSchema';

export type ExitFromParkingFormSchemaValues = z.infer<typeof exitFromParkingFormSchema>;
export const exitFromParkingFormSchema = z.object({
    exit_gateway: z.string().nonempty(),
    open_gateway: z.boolean(),
});

export type ConvertActiveStayToMembershipFormSchemaValues = z.infer<typeof convertActiveStayToMembershipFormSchema>;
export const convertActiveStayToMembershipFormSchema = membershipFormSchema.extend({
    active_stay: z.string(),
    is_validated: z.boolean(),
});
